<template>
  <form @submit.prevent="submitForm">
    <FormField
      id="Modulo_cod"
      label="Cu00f3digo"
      type="text"
      v-model="formData.Modulo_cod"
      :readonly="isEditing"
      :required="true"
      :maxlength="20"
      helpText="Cu00f3digo amigable del mu00f3dulo"
    />
    
    <FormField
      id="Nombre"
      label="Nombre"
      type="text"
      v-model="formData.Nombre"
      :required="true"
      :maxlength="100"
      helpText="Nombre del mu00f3dulo (mu00e1ximo 100 caracteres)"
    />
    
    <FormField
      id="Ruta"
      label="Ruta"
      type="text"
      v-model="formData.Ruta"
      :maxlength="255"
      helpText="Ruta de acceso MVC. Se usa para la validaciu00f3n de acceso"
    />
    
    <FormField
      id="RutaApi"
      label="Ruta API"
      type="text"
      v-model="formData.RutaApi"
      :maxlength="255"
      helpText="Ruta de acceso para la API"
    />
    
    <FormField
      id="Permisos"
      label="Permisos"
      type="number"
      v-model="formData.Permisos"
      helpText="Posibles permisos permitidos"
    />
    
    <FormField
      id="Es_activo"
      label="Estado"
      type="checkbox"
      v-model="formData.Es_activo"
      checkboxLabel="Mu00f3dulo activo"
      helpText="Indica si el mu00f3dulo estu00e1 activo en el sistema"
    />
    
    <div class="d-flex gap-2 mt-4">
      <button type="button" class="btn btn-primary" :disabled="loading" @click="submitForm">
        <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        <i v-else class="bi bi-save me-1"></i>
        {{ isEditing ? 'Actualizar' : 'Guardar' }}
      </button>
      <button type="button" class="btn btn-secondary" @click="$emit('cancel')">
        <i class="bi bi-x-circle me-1"></i> Cancelar
      </button>
    </div>
  </form>
</template>

<script>
import FormField from '@/shared/components/FormField.vue';

export default {
  name: 'ModuloForm',
  components: {
    FormField
  },
  props: {
    modulo: {
      type: Object,
      default: () => ({
        Modulo_cod: '',
        Nombre: '',
        Ruta: '',
        RutaApi: '',
        Permisos: 0,
        Es_activo: true
      })
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: { ...this.modulo }
    };
  },
  watch: {
    modulo: {
      handler(newValue) {
        this.formData = { ...newValue };
      },
      deep: true
    }
  },
  methods: {
    submitForm() {
      this.$emit('submit', { ...this.formData });
    }
  }
};
</script>
